module.exports = __webpack_public_path__ + "img/117-angola.f2d09c05.svg";